import { render, staticRenderFns } from "./MyCustomComp.vue?vue&type=template&id=45eacf64&"
import script from "./MyCustomComp.vue?vue&type=script&lang=js&"
export * from "./MyCustomComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports